<app-landing-navbar></app-landing-navbar>

<!-- Section 1: Hero Section -->
<section class="section-hero">
  <div class="hero-banner">
    <div class="hero-content">
      <h1 class="hero-header">Get your business<br>on the radio the easy way</h1>
      <p class="hero-subheader">Reach your customers on the radio stations they know and love.</p>
      <button class="btn-get-started" routerLink="/signup">Get Started</button>
    </div>
  </div>
</section>

<!-- Section 2: About Section -->
<section class="section-about">
  <div class="about-container">
    <div class="about-content">
      <h2 class="about-heading">Radio Ads Direct is made for businesses like yours</h2>
      <p class="about-paragraph">
        For many small businesses, radio advertising has always felt out of reach, overwhelming, or too complicated.
        Radio Ads Direct changes that by giving you a simple, self-serve way to create and book radio ads right from
        your computer, without needing to talk to a salesperson.
      </p>
      <p class="about-paragraph">
        Whether you're promoting a big sale, organizing a local event, promoting a community fundraiser, or even
        sharing a memorable birthday greeting for a loved one, it's never been easier to get your message on the
        air and reach listeners in your community.
      </p>
    </div>
    <div class="about-video">
      <div class="video-placeholder">
        <div class="play-button">▶</div>
      </div>
    </div>
  </div>
</section>

<!-- Section 3: Why Radio Section -->
<section class="section-why-radio">
  <div class="why-radio-overlay">
    <div class="main-card">
      <h2 class="main-card-heading">Radio is a megaphone for your business</h2>
      <p class="main-card-content">
        Radio remains one of the most trusted ways to connect with you customers. It keeps people company in
        meaningful moments - at work, on the road, at home, or even while tackling their next passion project.
        In a world full of screens and distractions, radio cuts through the noise.
      </p>
    </div>

    <div class="stats-cards">
      <div class="stat-card">
        <p class="stat-text-up">For small businesses using radio, consumers are</p>
        <p class="stat-number">40%</p>
        <p class="stat-text-down">more likely to remember a brand above any competitor</p>
      </div>

      <div class="stat-card">
        <p class="stat-text-up">AM/FM radio ads delivered</p>
        <p class="stat-number">10X</p>
        <p class="stat-text-down">in sales for every $1 spent on average</p>
      </div>

      <div class="stat-card">
        <p class="stat-text-up">On average, radio ads drove</p>
        <p class="stat-number">22%</p>
        <p class="stat-text-down">more foot traffic to stores that advertised</p>
      </div>
    </div>

    <button class="btn-discover">DISCOVER WHY RADIO IS SO POWERFUL</button>
  </div>
</section>

<!-- Section 4: How It Works -->
<section class="section-how-it-works">
  <div class="how-it-works-container">
    <h2 class="section-heading">How it works</h2>
    <p class="section-subheading">In just 3 easy steps, your radio ad campaign could start as early as tomorrow.</p>

    <div class="steps-cards">
      <div class="step-card">
        <div class="step-icon">
          <img src="assets/icons/CellTower.svg" alt="Add Icon" />
        </div>
        <p class="step-preheading">Step 01</p>
        <h3 class="step-heading">Create Your Ad</h3>
        <p class="step-content">
          Record your ad directly in the platform using your computer, upload a pre-recorded .mp3, or answer a
          few quick questions and we'll help you create an ad for free.
        </p>
      </div>

      <div class="step-card">
        <div class="step-icon">
          <img src="assets/icons/Microphone.svg" alt="WiFi Icon" />
        </div>
        <p class="step-preheading">Step 02</p>
        <h3 class="step-heading">Pick Your Stations</h3>
        <p class="step-content">
          Pick where you want to be heard by choosing the local stations that best reach your ideal audience.
          You can run your ads on one station or several at once.
        </p>
      </div>

      <div class="step-card">
        <div class="step-icon">
          <img src="assets/icons/CalendarDots.svg" alt="WiFi Icon" />
        </div>
        <p class="step-preheading">Step 03</p>
        <h3 class="step-heading">Set Your Schedule</h3>
        <p class="step-content">
          Pick when your campaign starts and ends, choose the days and times you want it to air, and see exactly
          when your ad will run so you can tune in if you'd like.
        </p>
      </div>
    </div>

    <button class="btn-get-started-now">GET STARTED NOW</button>
  </div>
</section>

<!-- Section 5: Budget Calculator -->
<section class="section-budget">
  <div class="budget-container">
    <h2 class="section-heading">Know what you'll pay before you start</h2>
    <p class="section-subheading">Use Radio Ad Direct's on-air schedule builder to instantly determine the cost of your
      ads and how many people they will reach - before you buy.</p>

    <div class="budget-content">
      <div class="budget-text">
        <p class="budget-paragraph">
          Radio remains one of the most cost-effective ways to reach customers. With our sample on-air schedule builder,
          you can explore real pricing and audience estimates before you sign up — no commitment or account required.
          Adjust your budget, choose your radio stations, and see how far your campaign can go.
        </p>
        <button class="btn-budget">SEE HOW FAR YOUR BUDGET GOES</button>
      </div>
      <div class="budget-image">
        <div class="image-placeholder">
          <p>SLIDER UI SCREENSHOT</p>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Section 6: Why Use RAD -->
<section class="section-why-rad">
  <div class="why-rad-container">
    <h2 class="section-heading">Why should you use Radio Ads Direct?</h2>
    <p class="section-subheading">Discover what makes Radio Ads Direct the easy way to advertise on air.</p>

    <div class="carousel-container">
      <div class="carousel-cards">
        <div class="carousel-track">
          <div class="feature-card" *ngFor="let card of duplicatedCards">
            <div class="feature-icon">
              <img [src]="card.icon" [alt]="card.heading" />
            </div>
            <h3 class="feature-heading">{{ card.heading }}</h3>
            <p class="feature-content">{{ card.content }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Section 7: Learning Library -->
<section class="section-learning">
  <div class="learning-container">
    <div class="learning-content">
      <h2 class="learning-heading">Learn how to get the most out of your campaigns</h2>
      <p class="learning-paragraph">
        Our Learning Library makes it easy to level up your radio advertising skills. Explore quick tutorials, campaign
        examples, and creative insights to help you get more from every ad — whether you're just starting out or ready
        to take your campaigns to the next level.
      </p>
      <button class="btn-learning">GO TO LEARNING LIBRARY</button>
    </div>
    <div class="learning-image">
      <img src="assets/home/image5.jpg" alt="Learning Library" class="learning-img-asset" />
    </div>
  </div>
</section>

<!-- Section 8: Contact Form -->
<section class="section-contact">
  <div class="contact-bg-overlay"></div>
  <div class="contact-content-container">
    <h2 class="contact-heading">Have questions? We're here to help.</h2>
    <p class="contact-subheading">Fill in the form below placeholder text</p>

    <div class="contact-form-container">
      <form class="contact-form">
        <input type="text" placeholder="Name" class="form-input" />
        <input type="email" placeholder="Email" class="form-input" />
        <textarea placeholder="Message" class="form-textarea"></textarea>
      </form>
    </div>

    <button class="btn-submit">Submit</button>
  </div>
</section>

<app-landing-footer></app-landing-footer>